import React from "react";
import { useNavigate } from "react-router-dom";

const CategoryCard = ({ category }) => {
  const router = useNavigate();
  return (
    <div
      key={category.id}
      onClick={() => {
        if (category.subcategories) {
          router(`/category/${category.name}`);
        } else {
          router(`/all-blog?category=${category.name}`);
        }
      }}
      className="bg-white rounded-lg shadow-md p-4 w-full cursor-pointer"
    >
      <img
        height={400}
        width={400}
        objectFit="cover"
        alt="example"
        src={category.image ? category.image : "/category/leet-codea.jpeg"}
        className="w-full h-[270px] object-contain object-center rounded-2xl"
      />
      <h2 className="mt-2">{category.name}</h2>
    </div>
  );
};

export default CategoryCard;
